import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const ShareIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}

            <mask
                id="mask0_393_7762"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="21"
            >
                <path d="M21 0H0V21H21V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_393_7762)">
                <path
                    d="M16.9168 12.8335C16.2547 12.8337 15.6026 12.9949 15.0168 13.3034C14.4309 13.6119 13.929 14.0583 13.5542 14.604L7.87498 12.0355C8.27091 11.055 8.27091 9.95913 7.87498 8.97865L13.5581 6.39828C14.1121 7.2023 14.9359 7.78113 15.8801 8.02974C16.8243 8.27835 17.8263 8.18028 18.7044 7.75331C19.5825 7.32634 20.2784 6.59877 20.666 5.7026C21.0535 4.80642 21.107 3.80101 20.8167 2.86878C20.5264 1.93656 19.9116 1.13926 19.0837 0.621559C18.2559 0.103855 17.2699 -0.0999618 16.3047 0.0470854C15.3394 0.194133 14.4589 0.682302 13.8227 1.42303C13.1866 2.16375 12.8371 3.10796 12.8375 4.08434C12.8377 4.31659 12.8574 4.54842 12.8966 4.77734L6.86829 7.5139C6.28703 6.97191 5.56024 6.61133 4.77703 6.47638C3.99383 6.34142 3.18827 6.43796 2.45914 6.75416C1.73 7.07036 1.10899 7.59247 0.67226 8.25646C0.23553 8.92045 0.00206516 9.69746 0.000496241 10.4922C-0.00107267 11.2869 0.229322 12.0649 0.663428 12.7306C1.09753 13.3963 1.71648 13.9208 2.44436 14.2399C3.17224 14.559 3.97741 14.6587 4.76114 14.5269C5.54487 14.395 6.27308 14.0373 6.85648 13.4976L12.894 16.225C12.7522 17.0501 12.8674 17.8988 13.2241 18.6562C13.5807 19.4137 14.1616 20.0431 14.888 20.4594C15.6144 20.8756 16.4512 21.0585 17.285 20.9833C18.1188 20.9081 18.9094 20.5784 19.5495 20.0389C20.1897 19.4993 20.6486 18.7761 20.8639 17.9671C21.0793 17.158 21.0408 16.3024 20.7536 15.516C20.4664 14.7296 19.9444 14.0504 19.2583 13.5706C18.5723 13.0908 17.7553 12.8335 16.9181 12.8335H16.9168Z"
                    fill="#1B1F30"
                />
            </g>
        </svg>
    );
};

export default ShareIcon;
